import { useState, useCallback } from "react";
import { ZohoContact } from "../types/zoho";
import axios from "axios";
import { LAMBDA_BASE_URL } from "../constants";
export function useRequestBindEmail() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [contactData, setContactData] = useState<ZohoContact | null>(null);

  const requestBindEmail = useCallback(
    async ({
      contactId,
      email,
      isSecondary,
    }: {
      contactId: string;
      email: string;
      isSecondary: boolean;
    }) => {
      const data: any = {
        id: contactId,
        email: isSecondary ? undefined : email,
        secondaryEmail: isSecondary ? email : undefined,
      };

      try {
        setLoading(true);
        setError(null);
        const response = await axios.post<any>(LAMBDA_BASE_URL, data, {
          data,
          params: {
            isUpdate: true,
          },
        });

        if (response.status !== 200) {
          throw new Error(response.data);
        }
        setContactData(response.data);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { loading, error, requestBindEmail, contactData };
}
